import ConsentForm from '@solvhealth/types/interfaces/ConsentForm';
import { EMPTY_ARRAY } from '~/core/util/array';
import { useSolvSelector } from '~/reducers';

const useConsentSectionContent = (bookingId: string) => {
  const paperwork = useSolvSelector((state) => state.paperwork);
  const booking = useSolvSelector((state) => state.pastBookings?.[bookingId]);

  if (!paperwork?.consentForms?.forms) {
    return EMPTY_ARRAY;
  }

  const signed = !!booking.consentFormsSignedDate || paperwork?.signatures?.success;

  return paperwork?.consentForms.forms.map((form: ConsentForm) => ({
    [form.id]: { displayName: form.display_name, value: signed ? 'Signed' : 'Unsigned' },
  }));
};

export default useConsentSectionContent;
